import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-warning-icon',
  templateUrl: './lib-warning-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibWarningIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
